import uuid from 'uuid/v4'
import { FileSelectorButton } from '../FileSelector'
import { AvatarCustom } from '@/style-guide'
import { Button } from 'antd'
import { useState } from 'react'
import { RightOutlined, LeftOutlined } from '@ant-design/icons'

export const InputImages = (props) => {
    const { value, onChange } = props || {}
    const [currentImageIndex, setCurrentImageIndex] = useState(0)

    const onSelect = (files) => {
        onChange(
            files?.map((f) => {
                return { id: uuid(), url: f }
            })
        )
    }

    const deleteImage = (picture) => {
        onChange(
            value?.filter((f) => {
                return f.id != picture.id
            })
        )
        // Reset current index if we're at the end
        if (currentImageIndex >= value.length - 1) {
            setCurrentImageIndex(Math.max(0, value.length - 2))
        }
    }

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % value.length)
    }

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + value.length) % value.length)
    }

    return (
        <>
            <div>
                <FileSelectorButton
                    title="Event photos"
                    maxCount={props.maxCount ? props.maxCount : 10}
                    type="image"
                    buttonType="default"
                    onSelect={onSelect}
                    organizationId={props.organizationId}
                    refLink={props.refLink}
                />
            </div>

            {value && value.length > 0 ? (
                <>
                    <div className="image-container">
                        {value.map((picture, idx) => (
                            <div
                                key={picture.id}
                                style={{
                                    width: '200px',
                                    position: 'relative',
                                    display: 'inline-block',
                                    marginRight: 8
                                }}
                            >
                                <AvatarCustom shape="square" src={picture.url} size={200} />
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        width: 28,
                                        height: 28,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 2
                                    }}
                                >
                                    <svg
                                        width="28"
                                        height="28"
                                        viewBox="0 0 28 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="14" cy="14" r="14" fill="#52C41A" />
                                    </svg>
                                    <span
                                        style={{
                                            position: 'absolute',
                                            color: 'white',
                                            fontWeight: 700,
                                            fontSize: 16,
                                            left: 0,
                                            right: 0,
                                            textAlign: 'center',
                                            top: 3
                                        }}
                                    >
                                        {idx + 1}
                                    </span>
                                </div>
                                <Button type="link" danger onClick={() => deleteImage(picture)}>
                                    Delete photo
                                </Button>
                            </div>
                        ))}
                    </div>

                    <div className="image-carousel-container">
                        <div className="image-carousel">
                            <AvatarCustom
                                shape="square"
                                src={value[currentImageIndex].url}
                                size={200}
                            />
                            {value.length > 1 && (
                                <>
                                    <Button
                                        className="carousel-arrow carousel-arrow-left"
                                        type="text"
                                        icon={<LeftOutlined />}
                                        onClick={prevImage}
                                    />
                                    <Button
                                        className="carousel-arrow carousel-arrow-right"
                                        type="text"
                                        icon={<RightOutlined />}
                                        onClick={nextImage}
                                    />
                                    <div className="image-counter">
                                        {currentImageIndex + 1} / {value.length}
                                    </div>
                                </>
                            )}
                        </div>
                        <Button
                            type="link"
                            danger
                            onClick={() => deleteImage(value[currentImageIndex])}
                        >
                            Delete photo
                        </Button>
                    </div>
                </>
            ) : (
                <div className="no-images-placeholder">No images selected</div>
            )}
        </>
    )
}